import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-card ${className}`} data-id="element-231">
      <div className={noPadding ? '' : 'p-5'} data-id="element-232">{children}</div>
    </div>;
}